/* RDD interactions use native HTML and are safe to initialise after editor changes. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const pagePath = url => {
    const route = url.searchParams.get('view');
    return route?.startsWith('rdd-') ? '/pages/' + route.slice(4) : url.pathname;
  };
  const activePath = pagePath(new URL(location.href));
  const closeMenus = () => document.querySelectorAll('.rdd-services-trigger').forEach(trigger => {
    if (trigger._rddClose) trigger._rddClose();
    else {trigger.setAttribute('aria-expanded','false');const menu=trigger.parentElement.querySelector('.rdd-services-menu');if(menu)menu.hidden=true;}
  });
  let id = 0;
  const revealShipping = (visual, restart = false) => {
    let scene = visual.querySelector('.shipping-scene');
    if (!scene) return;
    if (restart) {
      const fresh = scene.cloneNode(true);
      scene.replaceWith(fresh);scene = fresh;
    }
    scene.classList.remove('is-visible');
    if (reduce.matches || visual.dataset.rddInView === 'true') {
      // Restart the supplied entrance keyframes when switching region.
      void scene.offsetWidth;
      scene.classList.add('is-visible');
    }
  };
  const selectTab = (tabs, panel, focus = false) => {
    const panels = [...tabs.children].filter(el => el.matches('[role="tabpanel"]'));
    const buttons = [...tabs.querySelectorAll(':scope > [role="tablist"] > [role="tab"]')];
    panels.forEach((item, i) => {
      const active = item === panel;
      item.hidden = !active;
      item.dataset.state = active ? 'active' : 'inactive';
      buttons[i]?.setAttribute('aria-selected', String(active));
      if (buttons[i]) { buttons[i].tabIndex = active ? 0 : -1; buttons[i].dataset.state = item.dataset.state; }
      if (active && focus) buttons[i]?.focus();
    });
    const packingImage = tabs.closest('.pack-options-layout')?.querySelector('[data-rdd-pack-visual]');
    const selectedMedia = panel.querySelector('[data-rdd-panel-media] figure');
    if (packingImage && selectedMedia) {
      packingImage.replaceChildren(...[...selectedMedia.childNodes].map(node => node.cloneNode(true)));
    }
    const visual = tabs.closest('[data-rdd-section]')?.querySelector('.shipping-visual');
    if (visual && ['domestic', 'international'].includes(panel.dataset.panel)) {
      const geography = visual.querySelector('.shipping-geography');
      const region = panel.dataset.panel;
      const customImage = visual.dataset[region];
      geography.src = customImage || document.querySelector('[data-rdd-shipping-assets]')?.dataset[region] || geography.src;
      geography.classList.toggle('rdd-custom-geography',Boolean(customImage));
      geography.classList.toggle('domestic', region === 'domestic');
      geography.classList.toggle('international', region === 'international');
      visual.setAttribute('aria-label', region === 'domestic' ? 'USA map with orbiting lines and the RDD mark' : 'World globe with orbiting lines and the RDD mark');
      revealShipping(visual, true);
    }
  };
  function initialise(root = document) {
    root.querySelectorAll('.rdd-desktop-nav a').forEach(link => {
      const active = pagePath(new URL(link.href)) === activePath;
      link.dataset.active = String(active);
      if (active) link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');
    });
    root.querySelectorAll('.rdd-services-trigger').forEach(trigger => {
      trigger.classList.toggle('rdd-current',['services','warehousing','order-fulfillment','custom-packaging','campaign-fulfillment'].some(route=>activePath==='/pages/'+route));
      if (trigger.dataset.rddReady) return;
      trigger.dataset.rddReady='true';
      const row=trigger.parentElement,menu=row.querySelector('.rdd-services-menu');
      let openTimer,closeTimer;
      const clear=()=>{clearTimeout(openTimer);clearTimeout(closeTimer);};
      trigger._rddClose=()=>{clear();menu.hidden=true;trigger.setAttribute('aria-expanded','false');};
      trigger._rddCleanup=clear;
      row.addEventListener('pointerenter',event=>{
        if(event.pointerType==='touch'||!matchMedia('(hover: hover)').matches)return;
        clear();openTimer=setTimeout(()=>{menu.hidden=false;trigger.setAttribute('aria-expanded','true');},150);
      });
      row.addEventListener('pointerleave',()=>{clear();closeTimer=setTimeout(trigger._rddClose,150);});
    });
    root.querySelectorAll('.shipping-visual').forEach(visual => {
      if (visual.dataset.rddReady) return;
      visual.dataset.rddReady = 'true';
      const observer = new IntersectionObserver(entries => {
        visual.dataset.rddInView = String(entries[0].isIntersecting);
        revealShipping(visual);
      }, {threshold:.35});
      const sync = () => revealShipping(visual);
      observer.observe(visual);reduce.addEventListener('change', sync);
      visual._rddCleanup = () => {observer.disconnect();reduce.removeEventListener('change',sync);};
      if (reduce.matches) revealShipping(visual);
    });
    root.querySelectorAll('[data-rdd-tabs]').forEach(tabs => {
      const list = tabs.querySelector(':scope > [role="tablist"]');
      if (!list) return;
      list.replaceChildren();
      const panels = [...tabs.children].filter(el => el.matches('[role="tabpanel"]'));
      panels.forEach(panel => {
        const template = panel.querySelector('[data-rdd-trigger]');
        const button = template?.querySelector('button')?.cloneNode(true);
        if (!button) return;
        const unique = `rdd-tab-${++id}`;
        button.id = unique; panel.id = `${unique}-panel`;
        button.setAttribute('aria-controls', panel.id); panel.setAttribute('aria-labelledby', button.id);
        button.addEventListener('click', () => selectTab(tabs, panel));
        button.addEventListener('keydown', e => {
          const buttons = [...list.children]; const current = buttons.indexOf(button);
          let index;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') index = (current + 1) % panels.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') index = (current - 1 + panels.length) % panels.length;
          if (e.key === 'Home') index = 0;
          if (e.key === 'End') index = panels.length - 1;
          if (index !== undefined) { e.preventDefault(); selectTab(tabs, panels[index], true); }
        });
        list.append(button);
      });
      const initial = panels.find(p => p.dataset.panel === tabs.dataset.defaultTab) || panels[0];
      if (initial) selectTab(tabs, initial);
    });
    root.querySelectorAll('.marquee-track').forEach(track => {
      track.querySelectorAll('[data-rdd-clone]').forEach(el => el.remove());
      const original = track.querySelector('.marquee-group');
      if (!original) return;
      const clone = original.cloneNode(true); clone.setAttribute('aria-hidden', 'true');clone.setAttribute('inert', '');clone.dataset.rddClone = '';
      clone.querySelectorAll('[data-shopify-editor-block], [id]').forEach(el => {el.removeAttribute('data-shopify-editor-block');el.removeAttribute('id');});
      track.append(clone);
    });
    root.querySelectorAll('details[data-slot="accordion-item"]').forEach(detail => {
      if (detail.dataset.rddReady) return; detail.dataset.rddReady = 'true';
      detail.addEventListener('toggle', () => {
        detail.dataset.state = detail.open ? 'open' : 'closed';
        if (detail.open) [...detail.parentElement.children].filter(el => el !== detail && el.tagName === 'DETAILS').forEach(el => el.open = false);
      });
    });
    root.querySelectorAll('video[data-rdd-video]').forEach(video => {
      if (video.dataset.rddReady) return; video.dataset.rddReady = 'true';
      const button = video.closest('figure')?.querySelector('.film-control');
      const update = () => { if (button) {button.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} warehouse video`);button.textContent = video.paused ? '▶' : 'Ⅱ';} };
      video.addEventListener('play', update); video.addEventListener('pause', update);
      const sync = () => {if (video.dataset.visible === 'true' && !reduce.matches && !document.hidden && video.dataset.userPaused !== 'true') video.play().catch(() => {});else video.pause();};
      const observer = new IntersectionObserver(entries => {video.dataset.visible = String(entries[0].isIntersecting); sync();}, {threshold:.15});
      observer.observe(video); video._rddCleanup = () => {observer.disconnect();reduce.removeEventListener('change', sync);document.removeEventListener('visibilitychange', sync);};
      reduce.addEventListener('change', sync);document.addEventListener('visibilitychange', sync);
      button?.addEventListener('click', () => {if(video.paused){video.dataset.userPaused = 'false';video.play().catch(() => {});}else{video.dataset.userPaused = 'true';video.pause();}});update();
    });
    const mobile = document.querySelector('[data-rdd-mobile] nav');
    if (mobile) {
      const groups = [...mobile.querySelectorAll(':scope > div')];
      groups.forEach(group => group.querySelectorAll('a').forEach(link => link.remove()));
      const arrow = document.querySelector('.rdd-header-quote svg');
      const appendLink = (link, group) => {
        if (!group) return;
        const copy = document.createElement('a');
        copy.setAttribute('href', link.getAttribute('href'));
        copy.textContent = link.querySelector('strong')?.textContent || link.textContent;
        if (pagePath(new URL(link.href)) === activePath) copy.setAttribute('aria-current','page');
        if (arrow) {const icon = arrow.cloneNode(true);icon.setAttribute('width','17');icon.setAttribute('height','17');copy.append(icon);}
        copy.addEventListener('click', () => copy.closest('dialog')?.close());
        group.append(copy);
      };
      document.querySelectorAll('.rdd-menu-links a').forEach(link => appendLink(link, groups[0]));
      document.querySelectorAll('.rdd-nav-list>.rdd-nav-link,.rdd-nav-list>li>a').forEach(link => appendLink(link, groups[1]));
      const home = document.createElement('a');home.href='/';home.textContent=mobile.dataset.homeLabel || 'Home';appendLink(home,groups[1]);
    }
    const header = document.querySelector('.rdd-header-wrap');
    if (header) document.documentElement.style.setProperty('--header-offset', `${header.offsetHeight + 16}px`);
    const query = new URLSearchParams(location.search);
    root.querySelectorAll('.rdd-inquiry-form [name="contact[Service]"]').forEach(field => {
      const service = query.get('service');
      if (service && [...field.options].some(option => option.value === service)) field.value = service;
    });
    // Both native contact forms can receive Shopify's response. Use the
    // submitted form anchor, then prefer the visible inline form.
    const feedbacks = [...document.querySelectorAll('[data-rdd-form-feedback]')];
    const submittedId = decodeURIComponent(location.hash.slice(1));
    const feedback = feedbacks.find(el => el.closest('form')?.id === submittedId)
      || feedbacks.find(el => el.closest('.rdd-inquiry-form')) || feedbacks[0];
    if (feedback && !feedback.dataset.rddAnnounced) {
      feedback.dataset.rddAnnounced = 'true';
      const dialog = feedback.closest('dialog');
      if (dialog && !dialog.open) dialog.showModal();
      feedback.focus();
    }
  }
  let opener;
  function openDialog(dialog, source) {
    document.querySelectorAll('dialog[open]').forEach(el => el.close());
    opener = source;dialog?.showModal();
    const field = dialog?.querySelector('[name="contact[Service]"]');
    if (field) {
      field.querySelectorAll('[data-rdd-context]').forEach(option => option.remove());
      const service = source?.dataset.service || source?.closest('[data-panel]')?.querySelector('h3')?.textContent;
      if (service) {
        if (![...field.options].some(option => option.value === service)) {
          const option = document.createElement('option');option.textContent=service;option.dataset.rddContext='';field.append(option);
        }
        field.value = service;
      }
    }
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('.rdd-desktop-nav')) closeMenus();
    const target = event.target.closest('a,button,dialog');
    if (!target) return;
    if (target.matches('[data-rdd-quote]')) {event.preventDefault();openDialog(document.querySelector('[data-rdd-quote-dialog]'), target);}
    else if (target.matches('.rdd-mobile-trigger')) openDialog(document.querySelector('[data-rdd-mobile]'),target);
    else if (target.matches('[data-rdd-close]')) {target.closest('dialog')?.close();opener?.focus();}
    else if (target.matches('.rdd-services-trigger')) {
      const menu = target.parentElement.querySelector('.rdd-services-menu');menu.hidden = !menu.hidden;target.setAttribute('aria-expanded',String(!menu.hidden));
    } else if (target.matches('a[href^="#"]') && target.hash !== '#rdd-quote') {
      const anchor = target.hash.slice(1);const destination = document.querySelector(`[data-rdd-anchor="${CSS.escape(anchor)}"]`) || document.getElementById(anchor);
      if(destination){event.preventDefault();destination.scrollIntoView({behavior:reduce.matches?'instant':'smooth'});}
    }
  });
  document.addEventListener('keydown', e => {if(e.key==='Escape')closeMenus();});
  document.addEventListener('shopify:section:load', e => initialise(e.target));
  document.addEventListener('shopify:section:reorder', () => initialise());
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('video,.shipping-visual,.rdd-services-trigger').forEach(v=>v._rddCleanup?.()));
  document.addEventListener('shopify:block:select', e => {
    const panel=e.target.closest('[role="tabpanel"]');if(panel)selectTab(panel.closest('[data-rdd-tabs]'),panel);
    const detail=e.target.closest('details');if(detail)detail.open=true;
  });
  initialise();
  if (location.hash && !window.Shopify?.designMode) {
    const key = decodeURIComponent(location.hash.slice(1));
    const target = document.querySelector(`[data-rdd-anchor="${CSS.escape(key)}"]`);
    if (target) target.scrollIntoView({behavior:'instant'});
  }
})();
